<template>
	<CountUp :end-val="points" :options="options" style="display: inline-block;" />
</template>

<script setup>
import { computed, ref } from 'vue';
import CountUp from 'vue-countup-v3'
import { useUserStore } from '@/js/stores/user';

const userStore = useUserStore()

// Reactives
const options = ref({
	useGrouping: false,
	duration: 1,
	useEasing: true,
})

// Computeds
const points = computed(() => userStore.userTotalPoints > 0 ? userStore.userTotalPoints : 0)
</script>
